import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <motion.header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white/95 backdrop-blur-md'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <nav className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/">
            <motion.div
              className="flex items-center space-x-3"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              <div className="w-12 h-12 from-jetBlue-600 to-red-600 rounded-xl flex items-center justify-center shadow-lg">
                {/* <span className="text-white font-bold text-xl">JDI</span> */}
                <img src="/jetdigital.png" alt="Jet Digital Infotech Logo" className="w-full h-full object-contain" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">
                  Jet Digital <span className="text-jetBlue-600">Infotech</span>
                </h1>
                <p className="text-xs text-gray-600 font-medium">India's No. 1 Political Branding Agency</p>
              </div>
            </motion.div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium"
            >
              Home
            </button>
            <Link to="/political-wins" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium">
              Political Wins
            </Link>
            <Link to="/strategy" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium">
              Strategy
            </Link>
            <Link to="/portfolio" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium">
              Portfolio
            </Link>
            {/* <button
              onClick={() => scrollToSection('process')}
              className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium"
            >
              Process
            </button> */}
            <Link to="/services" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium">
              Services
            </Link>
            <Link to="/client-onboarding" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium">
              Client Onboarding
            </Link>
            <motion.button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-red-600 to-jetBlue-800 hover:from-red-700 hover:to-jetBlue-900 text-white font-bold py-3 px-6 rounded-xl transition-all duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Book Strategy Call
            </motion.button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-md text-gray-700 hover:text-jetBlue-600"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <motion.div
            className="lg:hidden py-4 border-t border-gray-200"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
          >
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium text-left"
              >
                Home
              </button>
              <Link to="/political-wins" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium text-left">
                Political Wins
              </Link>
              <Link to="/strategy" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium text-left">
                Strategy
              </Link>
              <Link to="/portfolio" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium text-left">
                Portfolio
              </Link>
              <button
                onClick={() => scrollToSection('process')}
                className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium text-left"
              >
                Process
              </button>
              <Link to="/services" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium text-left">
                Services
              </Link>
              <Link to="/client-onboarding" className="text-gray-700 hover:text-jetBlue-600 transition-colors font-medium text-left">
                Client Onboarding
              </Link>
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-red-600 to-jetBlue-800 text-white font-bold py-3 px-6 rounded-xl text-left"
              >
                Book Strategy Call
              </button>
            </div>
          </motion.div>
        )}
      </nav>
    </motion.header>
  );
};

export default Header;
